import { capitalize } from '@repo-level/core-front';
import { FC } from 'react';
import { ScFormSection } from './styled';

interface FormSectionProps {
  title?: string;
}

export const FormSection: FC<FormSectionProps> = ({ title, children }) => {
  return (
    <ScFormSection>
      {title && <div className="title">{capitalize(title)}</div>}
      {children}
    </ScFormSection>
  );
};
